// extracted by mini-css-extract-plugin
export default {"icon":"JupyterNotebookIcon_icon__6BMHJ"};